const key = 'projectCodeForGLSSSO';

const save = (projectCode: string) => {
  window.localStorage.setItem(key, projectCode);
};

const get = () => {
  const projectCode = window.localStorage.getItem(key);
  remove();

  return projectCode;
};

const remove = () => {
  window.localStorage.removeItem(key);
};

export const ProjectCodeForGLSSSO = { save, get };
